export default [
  // 企业设置
  {
    path: '/main/enterpriseSetting',
    name: 'enterpriseSetting',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/enterprise')
  },
  // 项目设置
  {
    path: '/main/spaceManage',
    name: 'spaceManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/project/project.vue')
  },
  {
    path: '/main/partitionSpace',
    name: 'partitionSpace',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/partitionSpace/partitionSpace.vue')
  },
  {
    path: '/main/authManage',
    name: 'authManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/authManage/authManage.vue')
  },
  {
    path: '/main/visitorReview',
    name: 'visitorReview',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/visitorReview/visitorReview.vue')
  },
  {
    path: '/main/messageReceiver',
    name: 'messageReceiver',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/messageReceiver/messageReceiver.vue')
  },
  {
    path: '/main/menuButtonManage',
    name: 'menuButtonManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/menuButtonManage/menuButtonManage.vue')
  },
  {
    path: '/main/faceAudit',
    name: 'faceAudit',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/faceAudit/faceAudit.vue')
  },
  {
    path: '/main/faceAuditProject',
    name: 'faceAuditProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/faceAuditProject/faceAuditProject.vue')
  }, {
    path: '/main/accountManage',
    name: 'accountManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/accountManage/accountManage.vue')
  },
  {
    path: '/main/callNumberSetting',
    name: 'callNumberSetting',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/callNumberSetting/callNumberSetting.vue')
  }, {
    path: '/main/callNumberSettingProject',
    name: 'callNumberSettingProject',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/callNumberSetting/callNumberSettingProject.vue')
  }, {
    path: '/main/dataDictionary',
    name: 'dataDictionary',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/dataDictionary/dataDictionary.vue')
  }, {
    path: '/main/beaconManage',
    name: 'beaconManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/beaconManage/beaconManage.vue')
  }, {
    path: '/main/projectConfig',
    name: 'projectConfig',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/projectConfig/index.vue')
  }, {
    path: '/main/ladderControl',
    name: 'ladderControl',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/ladderControlUpdate/ladderControlUpdate.vue')
  }, {
    path: '/main/statistics',
    name: 'statistics',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/statistics/statistics.vue')
  }, {
    path: '/main/deviceSoftwareVersionManage',
    name: 'deviceSoftwareVersionManage',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/deviceSoftwareVersionManage.vue')
  }, {
    path: '/main/parameterSetting',
    name: 'parameterSetting',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/parameterSetting')
  },
  {
    path: '/main/tripleManagement',
    name: 'tripleManagement',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: 'setting' */ '../pages/setting/tripleManagement.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/setting.js